/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@material-ui/core';
import useStyles from './useStyles';

export const FAQ = ({
  questions,
  title,
}) => {
  const classes = useStyles();

  // Función para convertir URLs en texto a enlaces clickeables
  const renderTextWithLinks = (text) => {
    if (!text) return text;

    // Regex para detectar URLs (http, https, www)
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part) => {
      if (urlRegex.test(part)) {
        let href = part;
        if (!part.startsWith('http')) {
          href = `https://${part}`;
        }

        return (
          <Link
            key={`link-${part}-${Math.random()}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            {part}
          </Link>
        );
      }
      return part;
    });
  };
  return (
    <Box variant="section" className={classes.container}>
      <Box variant="div" className={classes.innerContainer}>
        <Box variant="div" className={classes.containerQuestion}>
          <Box variant="div" className={classes.header}>
            <Typography variant="h2" className={classes.title}>{title}</Typography>
          </Box>
          <Box variant="div" className={classes.questions}>
            {
              questions.map(({
                label,
                body,
              }) => (
                <Box variant="div" className={classes.question}>
                  <Typography variant="h2" className={classes.label}>{label}</Typography>
                  <Typography variant="h2" className={classes.body}>
                    {renderTextWithLinks(body)}
                  </Typography>
                </Box>
              ))
            }
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

FAQ.propTypes = {
  questions: PropTypes.array,
  title: PropTypes.string,
};

FAQ.defaultProps = {
  questions: [],
  title: '',
};
